import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import "@/App.css";

import Login from "@/pages/Login";
import ControlTower from "@/pages/ControlTower";
import Shipments from "@/pages/Shipments";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Fleet from "@/pages/Fleet";
import Carbon from "@/pages/Carbon";
import Alerts from "@/pages/Alerts";
import Tenants from "@/pages/Tenants";
import DriverView from "@/pages/DriverView";
import ReceiverView from "@/pages/ReceiverView";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  const map = { driver: "/driver", receiver: "/receive", superadmin: "/tenants", tenant_admin: "/control-tower" };
  return <Navigate to={map[user.role] || "/control-tower"} replace />;
}

const admin = ["tenant_admin", "superadmin"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/tenants" element={<Protected roles={["superadmin"]}><Tenants /></Protected>} />
            <Route path="/control-tower" element={<Protected roles={["tenant_admin"]}><ControlTower /></Protected>} />
            <Route path="/shipments" element={<Protected roles={["tenant_admin"]}><Shipments /></Protected>} />
            <Route path="/shipments/:id" element={<Protected roles={["tenant_admin"]}><ShipmentDetail /></Protected>} />
            <Route path="/fleet" element={<Protected roles={["tenant_admin"]}><Fleet /></Protected>} />
            <Route path="/carbon" element={<Protected roles={admin}><Carbon /></Protected>} />
            <Route path="/alerts" element={<Protected roles={["tenant_admin"]}><Alerts /></Protected>} />
            <Route path="/driver" element={<Protected roles={["driver"]}><DriverView /></Protected>} />
            <Route path="/receive" element={<Protected roles={["receiver", "tenant_admin", "superadmin"]}><ReceiverView /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
